module.exports = __webpack_public_path__ + "e40da3bf0da2a687c8228ba728ca60cd.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/font/RobotoCondensed-Bold.ttf
 ** module id = 909
 ** module chunks = 9
 **/